import { useEffect, useState } from "react";

const Avatar = ({
    src,
    initials,
    onClick,
    dimension = "40px",
    color = "var(--black)",
    backgroundColor = "var(--lightGrey)",
}) => {
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        setFailed(false);
    }, [src]);
    const showPhoto = Boolean(src) && !failed;

    return (
        <div
            style={{
                borderRadius: "50%",
                backgroundColor,
                cursor: onClick ? "pointer" : "default",
                width: dimension,
                height: dimension,
                overflow: "hidden",
                flexShrink: 0,
            }}
            onClick={onClick}
        >
            {showPhoto ? (
                <img
                    src={src}
                    alt=""
                    onError={() => setFailed(true)}
                    style={{
                        display: "block",
                        width: dimension,
                        height: dimension,
                        objectFit: "cover",
                    }}
                />
            ) : (
                <p
                    style={{
                        display: "grid",
                        placeItems: "center",
                        width: dimension,
                        height: dimension,
                        color,
                        fontSize: "1rem",
                        textTransform: "uppercase",
                    }}
                >
                    {initials}
                </p>
            )}
        </div>
    );
};

export default Avatar;
